import React from "react";

import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";

import { IBoolParamTypeDescriptor } from '../../database/interfaces/paramScript/IParamTypeDescriptor';

interface IBoolCardContentProps {
    typeDescriptor: IBoolParamTypeDescriptor;
    paramValue: any;
    onUpdateParamValue: (value: any) => void;
}

const BoolCardContent: React.FC<IBoolCardContentProps> = ({ typeDescriptor, paramValue, onUpdateParamValue }) => {
    const editable = typeDescriptor.editable ?? true;
    const readOnly = typeDescriptor.readOnly ?? false;

    const isEmpty = paramValue === "" || paramValue === undefined || paramValue === null;
    const checked = isEmpty ? (typeDescriptor.default ?? false) : String(paramValue) === "true";

    return typeDescriptor ? (
        <Tooltip title={typeDescriptor.tooltip ?? ""} arrow>
            <FormControlLabel
                control={
                    <Switch
                        checked={checked}
                        disabled={!editable || readOnly}
                        onChange={(e) => onUpdateParamValue(e.target.checked)}
                    />
                }
                label={typeDescriptor.label || ""}
            />
        </Tooltip>
    ) : null;
}

export default BoolCardContent;
